export default "<div class=\"outlet-container\">\r\n    <router-outlet></router-outlet>\r\n  </div>\r\n  \r\n  <dialog-container></dialog-container>\r\n  "